import Vue from "vue";
import configs from "../configs";

const ip = configs.apiBase;

const retrieve = async (pesquisa) => {
  const response = await Vue.prototype.$http.post(
    `${ip}/contabilista/pesquisa`,
    pesquisa,
  );
  return response;
};

const retrieveTipos = () => {
  return Vue.prototype.$http.get(`${ip}/contabilista/tipos`);
};

const insert = (contabilista) => {
  return Vue.prototype.$http.post(`${ip}/contabilista`, contabilista);
};

const update = (contabilista) => {
  return Vue.prototype.$http.put(`${ip}/contabilista`, contabilista);
};

export default {
  retrieve,
  retrieveTipos,
  insert,
  update,
};
